import { Routes } from '~/domains/common/constants/routes';
import { getVisibleUserEntriesCount } from '~/domains/contest/domains/common/utils/pickControl';

import { useContestContext } from '../context/ContestContext/ContestContext';

const useGamecenterHeader = () => {
  const { contest } = useContestContext();

  return {
    closeHref: Routes.gamecenter({
      contestId: contest.id,
      contestStatus: contest.status,
      userEntriesCount: getVisibleUserEntriesCount(contest),
    }),
  };
};

export default useGamecenterHeader;
